import React from "react";
import "./header-nav.scss";
import IconPromo from "../../../mui/JSXIcons/IconPromo";
import { useAppSelector } from "../../../../store/index.ts";
import useGameClick from "../../../../hooks/other/useGameClick.js";
import ShowContainer from "../../../mui/ShowContainer.jsx";
import CusButton from "../../../mui/custom_button/CusButton.jsx";
import IconChampionsCup from "../../../mui/JSXIcons/IconChampionsCup.jsx";
import useGetLink from "../../../../hooks/other/useGetLink.js";
import { ENUM_MODE_GAME } from "../../../../store/enums.js";
import { setHardModeGame } from "../../../../store/commonSlice.js";
import { useDispatch } from "react-redux";
import IconBonus from "../../../mui/JSXIcons/IconBonus.jsx";

export default function HeaderNav() {
  const { onGameClick } = useGameClick();

  const isTgBot = useAppSelector((state) => state.common.isTgBot);
  const sportBookGame = useAppSelector((state) => state.games.sportBookGame);
  const categoryWager = useAppSelector((state) => state.games.categoryWager);
  const isAuth = useAppSelector((state) => state.user.isAuth);
  const categoryLoading = useAppSelector((state) => state.games.categoryLoading);

  const promoLink = useGetLink("/promotions");
  const dispatch = useDispatch();

  // const activePromoClass = "active";
  // const activeWagerClass = "active";

  console.log("sportBookGame", sportBookGame);

  return (
    <nav className="header__nav">
      <ShowContainer condition={!categoryLoading}>
        <ShowContainer condition={sportBookGame && isAuth}>
          <CusButton
            icon={<IconChampionsCup />}
            text="SportBook"
            color="custom"
            defCusColor="gradient-blue"
            className="sportsbook"
            onClick={() => {
              dispatch(setHardModeGame(ENUM_MODE_GAME.real));
              onGameClick({ currentGame: sportBookGame, isChoose: false, url: "/game/" });
            }}
          />
        </ShowContainer>

        <ShowContainer condition={!isTgBot}>
          <CusButton className="promo" text="Promotions" icon={<IconPromo />} to={promoLink} />
        </ShowContainer>

        <ShowContainer condition={categoryWager.id}>
          <CusButton
            className="wager"
            text={categoryWager.name || "Wager games"}
            icon={<IconBonus />}
            to={`/wager_games`}
          />
        </ShowContainer>
      </ShowContainer>
    </nav>
  );
}
